// extracted by mini-css-extract-plugin
export default {"cls1":"FormButtons-CreateButtonBlock_cls1__mFehY","cls2":"FormButtons-CreateButtonBlock_cls2__ooiac FormButtons-CreateButtonBlock_cls1__mFehY"};